import React from 'react';
import {query} from 'api';
import PropTypes from 'prop-types';
import FormationItem from './formationItem';
import {lifecycle} from 'recompose';
//import {MainTitleDark, Container, Button} from './styles';

const FormationsPage = ({data}) => {
  if (!data) return null;

  return (
    <>
      {data.map(listData => (
        <FormationItem
          key={listData.id}
          date={listData.acf.formations_date}
          image={listData.acf.formations_carte}
          sous_titre={listData.acf.formations_sous_titre}
          titre={listData.acf.formations_lieu}
          buttonId={listData.id}
        />
      ))}
    </>
  );
};

FormationsPage.propTypes = {
  data: PropTypes.array,
};

export default FormationsPage
  |> lifecycle({
    componentDidMount() {
      const {data, onEndReached} = this.props;
      if (data.length === 0) {
        onEndReached();
      }
    },
  })
  |> query('getFormationsByPage', {loadingFullWidth: true}, ({page}) => `/${page}`);
